import React from 'react'
import './section_title.scss'

function section_title({ children, subtitle, type }) {
  return [
    <h1 key={children} className={`section_title_${type}`}>{children}</h1>,
    subtitle ? <p className={`section_subtitle section_subtitle_${type}`} key={subtitle}>{subtitle}</p> : ''
  ]
}

export default section_title